export default __webpack_public_path__ + "static/media/330_dummy2016-kosmetik01-de.c23d4a96.png";